import { useContext, useEffect, useState } from 'react';
import Skeleton from '../../../../../widgets/plug/Skeleton/Skeleton';
import UserContext from '../../../../../common/utils/getContext';
import { LangContext } from '../../../../../common/decorators/Language';
import T, { t } from '../../../../../common/components/T';
import css from './Feedback.module.scss';
import { getData, navigateV2 } from '../../../../../common/utils/router';
import FeedbackForm from '../../../components/FeedbackForm/FeedbackForm';

const RenderData = () => {
    // const { data = {} } = props;
    // const { text } = data;
    const { translation } = useContext(LangContext) || {};

    return (
        <div className={css.wrapper}>
            <div className={css.blockSendMessage}>
                <div className={css.blockSendText}>
                    <p className={css.writeUsText}>
                        <span className={css.writeUsTextLightText}>
                            <T textName='contact-us-big' defaultStr='Contact us' page='/contact' />
                        </span>
                        {t('contactPage-writeUs-v1', 'Свяжитесь с нами', '/contact', translation)}
                    </p>
                    {/* {text?.text && <p className={css.formTextMessage}>{parse(text?.text)}</p>} */}
                    <p className={css.leftBlockSendMessage}>
                        <T
                            textName='contact-feedback-message'
                            defaultStr='Вы можете обратиться в нашу службу поддержки по любому интересующему вопросу. В рабочее время мы отвечаем не дольше чем через 10 минут после обращения'
                            page='/contact'
                        />
                    </p>
                </div>
                <FeedbackForm />
            </div>
        </div>
    );
};
const Feedback = () => {
    const { userToken, lang } = useContext(UserContext);
    const [canSend, setCanSend] = useState(false);

    useEffect(() => {
        getData('/api/v1/feedback/queries/can-query', userToken, lang).then((res) => {
            if (res?.can_store_query) {
                setCanSend(true);
            } else {
                navigateV2('/store');
            }
        });
    }, [userToken, lang]);

    if (!canSend) return null;
    return <Skeleton Component={RenderData} wait={!!canSend} elements={[]} />;
};
export default Feedback;
